import IntroductionJackbox2Container from './introductionjackbox2'

export default IntroductionJackbox2Container